import { Toast as BaseToast } from '@base-ui/react/toast'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ToastDescriptionProps extends PartProps<BaseToast.Description.Props> {
  className?: string
}

function ToastDescription({ className, ...props }: ToastDescriptionProps) {
  return <BaseToast.Description className={twMerge('min-w-0 text-pretty text-sm', className)} {...props} />
}

export { ToastDescription }
